import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedItems } from '../data/content';
import { BookCollection } from './BookCollection';
import { LifestyleCarousel } from './LifestyleCarousel';
import { PageGallery } from './PageGallery';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section className="px-5 pb-6 pt-8 sm:px-6 md:px-8" data-id="element-207" data-mp="ptrek633g9gg">
      <div className="mx-auto max-w-[640px]" data-id="element-208" data-mp="b5wn0t0tob4y">
        <SectionHeading eyebrow="Everything included" data-id="element-209" data-mp="b551yc4upvsx">
          What will you <span className="accent-underline" data-id="element-210" data-mp="fy6jyt0cubgq">find</span> inside?
        </SectionHeading>

        <div className="mt-7 rounded-2xl border border-cream-300 bg-white px-6 py-6 text-center" data-id="element-211" data-mp="26jafrhej6g0">
          <p className="font-display text-[23px] font-semibold leading-[1.25] tracking-[-0.01em] text-ink-900" data-id="element-212" data-mp="741mvrumo3sr">
            120 curated projects and challenges
          </p>
          <p className="mt-2 text-[15.5px] leading-[1.6] text-ink-500" data-id="element-213" data-mp="3tc1h7m4n3a63">
            across six illustrated digital books — 20 in each, ordered so every book builds on the
            skills of the one before it.
          </p>
        </div>

        <LifestyleCarousel data-id="element-214" data-mp="37trrdcxsykit" />

        <ul className="mt-9 space-y-5" data-id="element-215" data-mp="37ukw68d7azyb">
          {includedItems.map(item => <li key={item.title} className="flex gap-3.5" data-id="element-216" data-mp="3lu2gaafjxp1c">
              <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-500/10" aria-hidden="true" data-id="element-217" data-mp="3hsh995pp84z2">
                <CheckIcon className="h-3 w-3 text-forest-600" strokeWidth={3} data-id="element-218" data-mp="2p4bju5np9rsw" />
              </span>
              <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-219" data-mp="32vhsoscvd1sg">
                <span className="font-semibold text-ink-900" data-id="element-220" data-mp="32xuly1o2uykt">{item.title}</span> {item.detail}
              </p>
            </li>)}
        </ul>
      </div>

      <BookCollection data-id="element-221" data-mp="2aedwfrxlh64r" />

      <div className="mx-auto max-w-[980px]" data-id="element-222" data-mp="2admal8tsumro">
        <PageGallery data-id="element-223" data-mp="26edf9zj42gu0" />
      </div>
    </section>;
}